export default () => ({

    options: [],
    selected_options: [],

    selected_options_str: '',

    state: {
        multiple: false,
        is_open: false,
        is_decoy: false,
        is_filtering_selected_options: false,
        has_collapse: false,
    },

    messages: {
        label: '',
        not_selected: '',
    },

    init() {

        // noinspection JSUnresolvedReference
        this.messages.label = this.$root.getAttribute('data-label');

        // noinspection JSUnresolvedReference
        this.messages.not_selected = this.$root.getAttribute('data-not-selected');

        // noinspection JSUnresolvedReference
        this.state.multiple = !!parseInt(this.$root.getAttribute('data-multiple'));

        // noinspection JSUnresolvedReference
        this.state.has_collapse = !!parseInt(this.$root.getAttribute('data-collapse'));

        // noinspection JSUnresolvedReference
        this.state.is_open = !!parseInt(this.$root.getAttribute('data-open'));

        // noinspection JSUnresolvedReference
        this.state.is_decoy = !!parseInt(this.$root.getAttribute('data-decoy'));

        // noinspection JSUnresolvedReference
        this.$watch('selected_options', (new_options, old_options) => {

            console.debug('[multiselect' + this.messages.label + '] Выбранные значения были обновлены');
            console.debug('Old:', old_options);
            console.debug('New:', new_options);

            this.selected_options_str = this.getSelectedOptionsDisplayValue();
        });

        // noinspection JSUnresolvedReference
        this.$watch('options', (new_options, old_options) => {

            console.debug('[multiselect' + this.messages.label + '] Опции были обновлены');
            console.debug('Old:', old_options);
            console.debug('New:', new_options);

            Alpine.nextTick().then(() => {
                this.selected_options_str = this.getSelectedOptionsDisplayValue();
            });
        });

        // noinspection JSUnresolvedReference
        const initialOptions = this.$root.dataset.options;

        if (initialOptions.length) {

            let options = JSON.parse(initialOptions);

            if (options.length) {
                console.debug('[multiselect' + this.messages.label + '] Установка начальных опций', initialOptions);

                this.options = options;
                this.options = this.options.map(option => {
                    option.value = option.value.toString()
                    return option;
                });
            }
        }

        Alpine.nextTick().then(() => {
            // noinspection JSUnresolvedReference
            const parsed = JSON.parse(this.$root.getAttribute('data-selected-options'));

            // Если атрибут пуст — значение уже пришло через x-modelable; не перезаписываем
            if (parsed.length > 0) {
                this.selected_options = parsed;
            }
        });
    },

    /**
     * Выбрать опцию
     */
    selectOption(option) {
        console.debug('[multiselect' + this.messages.label + '] Попытка выбора опции', option.value);

        if (this.isLinkOption(option)) {
            console.debug('[multiselect' + this.messages.label + '] Выполняется перенаправление по ссылке опции');
            window.location.href = option.value;
            return;
        }

        if (this.isSelected(option)) {
            console.debug('[multiselect' + this.messages.label + '] Опция уже является выбранной');
            return;
        }

        if (!this.state.multiple) {
            this.selected_options = [];

            if (!this.state.has_collapse) {
                this.state.is_open = false;
            }
        }

        this.selected_options.push(option.value);
        console.debug('[multiselect' + this.messages.label + '] Опция установлена как выбранная', option.value);
    },

    /**
     * Отключить опцию
     */
    deselectOption(option) {
        console.debug('[multiselect] Попытка отключения опции', option.value);

        if (!this.isSelected(option)) {
            console.debug('[multiselect] Опция уже является отключенной');
            return;
        } else {
            if (!this.state.multiple) {
                console.debug('[multiselect] Невозможно отключить единственную опцию (multiple=false)');
                return;
            }
        }

        this.selected_options = this.selected_options.filter(selected_value => selected_value !== option.value);
        console.debug('[multiselect' + this.messages.label + '] Опция отключена', option.value);
    },

    /**
     * Переключить опцию
     */
    toggleOption(option) {
        console.debug('[multiselect] Попытка переключения опции', option.value);

        if (this.isSelected(option)) {
            this.deselectOption(option);
            return;
        }

        if (option.disabled) {
            console.debug('[multiselect] Невозможно включить заблокированную опцию');
            return;
        }

        this.selectOption(option);
    },

    /**
     * Является ли опция включенной
     */
    isSelected(option) {
        return this.selected_options.includes(option.value);
    },

    /**
     * Является ли опция ссылкой
     */
    isLinkOption(option) {

        if (!option.hasOwnProperty('is_link')) {
            return false;
        }

        return option.is_link;
    },

    /**
     * Получить наименования активных опций через запятую
     */
    getSelectedOptionsCommaSeparated() {
        const validSelectedOptions = this.options
            .filter(option => this.selected_options.includes(option.value))
            .map(option => option.caption);

        // Если нет валидных выбранных опций, возвращаем null
        if (validSelectedOptions.length === 0) {
            return null;
        }

        return validSelectedOptions.join(', ');
    },

    /**
     * Получить текст для кнопки компонента
     */
    getSelectedOptionsDisplayValue() {
        const commaSeparated = this.getSelectedOptionsCommaSeparated();

        // Если нет валидных выбранных опций или метод вернул null
        if (!commaSeparated || !this.selected_options.length) {
            return this.messages.not_selected;
        }

        return commaSeparated;
    }
})